import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { getFiGrowthBook } from '../lib/growthbook';
import { userFreeTrialStatusQuery } from '../graphql-operations/UserIdentity.graphql';
import useCartHasFreeTrialBundle from './useCartHasFreeTrialBundle';

interface UserFreeTrialStatus {
  currentUser?: {
    userHouseholds?: Array<{
      household?: {
        pets?: Array<{
          device?: {
            subscription?: {
              hasFreeTrialPlan?: boolean | null;
            } | null;
          } | null;
        }>;
      };
    }>;
  };
}

/**
 * Returns false when the flag is off, a trial is already in cart,
 * or the user has an active trial subscription on any device.
 */
export default function useFreeTrialPromoVisible(): boolean {
  const isFlagEnabled = getFiGrowthBook().getFeatureValue<boolean>('free-trial-enabled', false);
  const hasFreeTrialInCart = useCartHasFreeTrialBundle();

  const { data: freeTrialData } = useQuery<UserFreeTrialStatus>(userFreeTrialStatusQuery, {
    skip: !isFlagEnabled || hasFreeTrialInCart,
  });

  const hasExistingFreeTrial = useMemo(() => {
    const households = freeTrialData?.currentUser?.userHouseholds ?? [];
    return households.some((h) => h.household?.pets?.some((p) => p.device?.subscription?.hasFreeTrialPlan === true));
  }, [freeTrialData]);

  return isFlagEnabled && !hasFreeTrialInCart && !hasExistingFreeTrial;
}
